var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"progress-bar"},[(_vm.hasProgressBar)?_c('v-progress-linear',{attrs:{"value":_vm.percentage,"height":"30","color":"#54B045","rounded":"","background-color":"#5E3824"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }